import React, { Component } from "react";
import "antd/dist/reset.css";
// import './TabNew.css';
import { Tabs, Button, DatePicker } from "antd";
import AttestationList from "./AttestationList";
//import AuthorizationDetails from "../AuthUsers/AuthorizationDetails";
import Axios from "axios";
import Config from "../../../src/config";
import { Link, Redirect } from "react-router-dom";
import "../../App.css";
import { authListObject } from "../../store/broadcaster/BroadcastRegister";

const { TabPane } = Tabs;
class NewTab extends Component {
  constructor(props) {
    super(props);
    this.newTabIndex = 0;
    const panes = [
      {
        title: "Attestations",
        content: (
          <div style={{ marginLeft: "0px" }}>
            {" "}
            <AttestationList
            //   activeKey={this.props.activeKey}
            />
          </div>
        ),
        key: "1",
        closable: false,
      },
      // { title: 'Member Details', content: 'Content of Tab Pane 2', key: '2' },
    ];
    this.state = {
      fromPage: this.props.hereFrom,
      count: 1,
      activeKey: panes[0].key,
      panes,
      TabButtons: null,
      activeTab:
        this.props.activetab === null ||
        this.props.activetab === undefined ||
        this.props.activetab === ""
          ? "1"
          : this.props.activetab,
    };
    // console.log("newtabjs constructor")
  }

  getAdmissionDetails = (user) => {
    console.log("called@@");
    this.add(user);
  };

  onChange = (activeKey) => {
    console.log("called here");
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    console.log("pppp");
    this[action](targetKey);
  };

  add = (user) => {
    //  console.log(user)
    // console.log(AdmissionID)

    const { panes } = this.state;
    var activeKey;
    var currentIndex = this.state.panes.findIndex((pane) =>
      pane.title.includes(user.Reference)
    );

    // if (currentIndex === -1) {
    //   activeKey = `newTab${this.newTabIndex++}`;
    //   panes.push({
    //     title: "Ref. ID:" + " " + user.Reference,
    //     content: <AuthorizationDetails user={user} />,
    //     key: activeKey,
    //   });
    // } else {
    //   activeKey = panes[currentIndex].key;
    // }
    this.setState({ panes, activeKey });
  };

  remove = (targetKey) => {
    console.log("ppp");
    let { activeKey } = this.state;
    let lastIndex;
    this.state.panes.forEach((pane, i) => {
      if (pane.key === targetKey) {
        lastIndex = i - 1;
      }
    });
    const panes = this.state.panes.filter((pane) => pane.key !== targetKey);
    if (panes.length && activeKey === targetKey) {
      if (lastIndex >= 0) {
        activeKey = panes[lastIndex].key;
      } else {
        activeKey = panes[0].key;
      }
    }
    this.setState({ panes, activeKey });
  };

  render() {
    this.state.count = this.state.count + 1;
    return (
      <div id="dTable">
        <div>
          <div
            className={
              this.state.activeTab === "1"
                ? "app-body-container"
                : "app-body-container-new"
            }
          >
            <div style={{ marginLeft: "-40px" }}>
              <Tabs
                hideAdd
                tabBarExtraContent={this.state.TabButtons}
                onChange={this.onChange}
                activeKey={this.state.activeKey}
                type="editable-card"
                onEdit={this.onEdit}
              >
                {this.state.panes.map((pane) => (
                  <TabPane
                    tab={pane.title}
                    key={pane.key}
                    closable={pane.closable}
                  >
                    {pane.content}
                  </TabPane>
                ))}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default NewTab;
